module.exports = __webpack_public_path__ + "img/illustration2.0547707c.svg";